 
import React, { useState,useEffect } from 'react';
import { MapPinIcon } from '@heroicons/react/24/outline'; // Heroicons v2 import
import { useNavigate } from 'react-router-dom';
import {  MdArrowBack } from 'react-icons/md';
import toast from 'react-hot-toast';
import { UpdatevendorbyId, createVendor } from '../../../api/api';

const AddVendor = ({onBack,isView,isEdit,vendor}) => {
    const [VendorData, setVendorData] = useState(vendor||{
        companyName: '',
        name: '',
        contactNo: '',
        email: '',
        gstNo : '',
        address:'',
        companyPhoto: null,
      });
      const [location, setLocation] = useState({ lat: '', lng: '' });
      const [error, setError] = useState('');
      const navigate = useNavigate();
    
      // Function to detect current location
      const detectLocation = () => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const { latitude, longitude } = position.coords;
              setLocation({ lat: latitude, lng: longitude });
              setError('');
            },
            (error) => {
              setError('Please enable location services to get your current location.');
            }
          );
        } else {
          setError('Geolocation is not supported by your browser.');
        }
      };
    
      // // Automatically detect location on mount
      // useEffect(() => {
      //   detectLocation();
      // }, []);
    
      // Handle form input changes
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setVendorData({
          ...VendorData,
          [name]: value,
        });
      };
    
      // Handle file upload
      const handleFileUpload = (e) => {
        setVendorData({
          ...VendorData,
          companyPhoto: e.target.files[0],
        });
      };
    
      // Handle form submission
      const handleSubmit = async(e) => {
        e.preventDefault();
        try {
      let res;

          if (isEdit) {
            res = await UpdatevendorbyId(vendor._id,VendorData); 
          } else {
            res = await createVendor(VendorData);
          }
          console.log(res);
          
          setVendorData({
            companyName: '',
            name: '',
            contactNo: '',
            email: '',
            gstNo : '',
        address:'',

            companyPhoto: null,
            
          })
          toast.success(res.message)
          onBack()
        } catch (error) {
          setError('An error occurred during signup.');
          toast.error(error.message)
        }
      };
      // useEffect(() => {
      //   if (Vendor) {
      //     if(isEdit || isView){
      //      setVendorData(Vendor);
      //     }
      //   }
      // }, [isEdit, Vendor]);

        
  return (
    <div className="max-w-4xl mx-auto mt-3 poppins-medium px-4 sm:px-6 lg:px-8">
    <div className="flex items-center mb-4">
      <MdArrowBack 
        className="text-xl cursor-pointer mr-2" 
        onClick={onBack}  
      />
      <h1 className="text-lg sm:text-xl font-semibold">
        {!vendor ? 'Add Vendor' : isEdit ? 'Edit Vendor' : 'View Vendor'}
      </h1>
    </div>
    
    <form 
      onSubmit={handleSubmit} 
      className="grid grid-cols-1 gap-4 sm:gap-6 md:gap-8 lg:gap-6 md:grid-cols-2 lg:grid-cols-3"
    >
      {/* Company Name */}
      <div className="col-span-1">
        <label className="block text-sm font-medium text-gray-700">Company Name</label>
        <input
          type="text"
          name="companyName"
          value={VendorData.companyName}
          onChange={handleInputChange}
          disabled={isView}
          className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-black focus:border-black"
          placeholder="Enter company name"
          required
        />
      </div>
  
      {/* Name */}
      <div className="col-span-1">
        <label className="block text-sm font-medium text-gray-700">Name</label>
        <input
          type="text"
          name="name"
          value={VendorData.name}
          onChange={handleInputChange}
          disabled={isView}
          className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-black focus:border-black"
          placeholder="Enter name"
          required
        />
      </div>
  
      {/* Contact Number */}
      <div className="col-span-1">
        <label className="block text-sm font-medium text-gray-700">Contact Number</label>
        <input
          type="number"
          name="contactNo"
          value={VendorData.contactNo}
          onChange={handleInputChange}
          disabled={isView}
          className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-black focus:border-black"
          placeholder="Enter mobile number"
          required
        />
      </div>
  
      {/* Email */}
      <div className="col-span-1">
        <label className="block text-sm font-medium text-gray-700">Email</label>
        <input
          type="email"
          name="email"
          value={VendorData.email}
          onChange={handleInputChange}
          disabled={isView || isEdit}
          className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-black focus:border-black"
          placeholder="Enter email"
          required
        />
      </div>
  
      {/* GST No */}
      <div className="col-span-1">
        <label className="block text-sm font-medium text-gray-700">GST No</label>
        <input
          type="text"
          name="gstNo"
          value={VendorData.gstNo}
          onChange={handleInputChange}
          disabled={isView}
          className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-black focus:border-black"
          placeholder="Enter GST No"
          required
        />
      </div>
  
      {/* Company Photo */}
      {!isView && (
        <div className="col-span-1">
          <label className="block text-sm font-medium text-gray-700">Upload Company Photo</label>
          <input
            type="file"
            onChange={handleFileUpload}
            className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-black focus:border-black"
          />
        </div>
      )}
      {vendor && (
        <div className="col-span-1 flex flex-col items-center">
          <span className="text-sm font-medium">Company Photo</span>
          <img src={vendor.companyPhoto} alt="Vendor company photo" className="w-24 h-24 rounded-md object-cover border border-gray-300 mt-2" />
        </div>
      )}
  
      {/* Address */}
      <div className="col-span-1 sm:col-span-2 lg:col-span-3">
        <label className="block text-sm font-medium text-gray-700">Address</label>
        <textarea
          name="address"
          value={VendorData.address}
          onChange={handleInputChange}
          disabled={isView}
          className="mt-1 w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-black focus:border-black"
          placeholder="Enter address"
          rows="3"
          required
        />
      </div>
  
      {/* Submit Button */}
      <div className="col-span-1 sm:col-span-2 lg:col-span-3 mt-6 text-center">
        {vendor && isEdit ? (
          <button
            type="submit"
            disabled={isView}
            className={`w-full py-3 px-4 bg-black text-white font-semibold rounded-md shadow focus:ring focus:ring-opacity-75 focus:ring-black ${isView ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            Update
          </button>
        ) : !vendor ? (
          <button
            type="submit"
            disabled={isView}
            className={`w-full py-3 px-4 bg-black text-white font-semibold rounded-md shadow focus:ring focus:ring-opacity-75 focus:ring-black ${isView ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            Submit
          </button>
        ) : null}
      </div>
    </form>
  </div>
  
  
  )
}

export default AddVendor